import fetch from 'auth/GenericFetchInterceptorV5'

const LotsService = {}

const queryStringCatalogLots = "populate=lot.product&populate=lot.warehouse_articles.storage&populate=lot.devices.patient"

LotsService.getLotsByCompany = function (companyDocId) {
    return fetch({
        url: `/api/cataloglots?${queryStringCatalogLots}&filters[company][documentId]=${companyDocId}`
    })
}

LotsService.getLotsByCompanyAfter = function (companyDocId, updatedAtISO) {
    return fetch({
        url: `/api/cataloglots?${queryStringCatalogLots}&filters[company][documentId]=${companyDocId}&filters[lot][updatedAt][$gt]=${updatedAtISO}`
    })
}

// New method to get just the count of lots for a company
LotsService.getLotsByCompanyCount = function (companyDocId) {
    return fetch({
        url: `/api/cataloglots?filters[company][documentId]=${companyDocId}&pagination[pageSize]=1&pagination[page]=1`
    })
}

// Create lots for an existing product
LotsService.createLotsForProduct = function (data) {
    return fetch({
        url: `/api/lots/v2/create-lots-for-product`,
        method: 'POST',
        data: data
    })
}
LotsService.getByDocumentId = function (documentId) {
    return fetch({
        url: `/api/lots/${documentId}?populate[0]=warehouse_articles&populate[1]=warehouse_articles.storage`,
        method: 'GET'
    })
}

LotsService.getByDocumentIdAll = function (documentId) {
    return fetch({
        url: `/api/lots/${documentId}?populate=*`,
        method: 'GET'
    })
}

LotsService.modifyLot = function (documentId,data) {
    return fetch({
        url: `/api/lots/${documentId}`,
        method: 'PUT',
        data: data
    })
}
LotsService.archiveLot = function (documentId, companyDocumentId, reason) {
    return fetch({
        url: `/api/lots/${encodeURIComponent(documentId)}/archive`,
        method: 'POST',
        data: {data: {companyDocumentId, reason}}
    })
}
LotsService.unarchiveLot = function (documentId, companyDocumentId) {
    return fetch({
        url: `/api/lots/${encodeURIComponent(documentId)}/unarchive`,
        method: 'POST',
        data: {data: {companyDocumentId}}
    })
}
LotsService.modifyWereHouseArticles = function (documentId,data) {
    return fetch({
        url: `/api/warehouse-articles/${documentId}?populate[lot]=true&populate[storage]=true`,
        method: 'PUT',
        data: data
    })
}
export default LotsService;
